import { AssetManagerSingleCardTemplate } from "../../../../../templates";
import { SendInvitationForm } from "../../../../shared";
import { useSendInvitation } from "./useSendInvitation";

export const SendInvitation = (): JSX.Element => {
  const { roles, rolesInfo, userSettingsRoute, handleBackClick } = useSendInvitation();
  return (
    <AssetManagerSingleCardTemplate
      activeElement="Settings"
      pageTitle="Invite new user"
      handleBackClick={handleBackClick}
    >
      <SendInvitationForm roles={roles} rolesInfo={rolesInfo} userSettingsRoute={userSettingsRoute} />
    </AssetManagerSingleCardTemplate>
  );
};
